import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import "./index.scss"

export default function PressSubHeader({ component }) {
  const {
    leftContent,
    rightContent,
    backgroundImage,
  } = component

  const img = getImage(backgroundImage)


  return (
    <section data-datocms-noindex className="press-subheader">
      <GatsbyImage
        image={img}
        alt="image"
        className="press-subheader__image"
      />
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="press-subheader__content" dangerouslySetInnerHTML={{__html: leftContent}}/>
          </div>
          <div className="col-md-6">
            <div className="press-subheader__content" dangerouslySetInnerHTML={{__html: rightContent}}/>
          </div>
        </div>
      </div>
    </section>
  )
}
